import { render } from "./PlanCardLegacy.vue?vue&type=template&id=68721d02&scoped=true&ts=true"
import script from "./PlanCardLegacy.vue?vue&type=script&lang=ts"
export * from "./PlanCardLegacy.vue?vue&type=script&lang=ts"

import "./PlanCardLegacy.vue?vue&type=style&index=0&id=68721d02&lang=sass&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68721d02"]])

export default __exports__